import React from 'react'
import { Meta, User, Button } from '../../../components'
import colors from '../../../utils/colors'
// import { Link } from 'react-router-dom'
import { ReportPopup } from './report-popup'
import { ActionButtons } from './action-buttons'

const ReportSection = ({ data }) => {
  console.log(data)
  const [popedUp, setPopedUp] = React.useState(false)

  return (
    <div>
      <Button className="hidden lg:block" onClick={() => setPopedUp(true)}>Download Final Report</Button>
      <Button className="lg:hidden" thin onClick={() => setPopedUp(true)}>Download Final Report</Button>
      {
        popedUp &&
        <ReportPopup title={data.title} onClose={() => setPopedUp(false)}/>
      }
    </div>
  )
}

// const Milestone = ({text, className, disabled}) => {
//   return (
//     <div className={`flex ${className}`}>
//       <div style={{background: disabled ? '#ddd' : colors.green, width: '12px', height: '12px'}} className="rounded-full mr-2 mt-1"></div>
//       <div className={`w-7/12 text-sm text-gray-444 ${disabled ? 'opacity-50' : ''}`}>
//         {text}
//       </div>
//       {
//         !disabled &&
//         <div className="ml-auto link">View Report</div>
//       }
//     </div>
//   )
// }

const Sidebar = ({isOfficial, bookmarkable, data}) => {
  return (
    <div>
      <div className="hidden lg:block">
        <ActionButtons bookmarkable={bookmarkable}/>

        <hr className="my-10"/>
      </div>

      {
        (data && data.organization) &&
        <User className="mb-5 lg:mb-8"/>
      }

      <div className="flex flex-wrap -mx-2 lg:mx-0 lg:block">
        <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-5 lg:mb-8 order-2 lg:order-1">
          <Meta
            label="Approach"
            value={data && data.approach ? data.approach : "Pencegahan"}
          />
        </div>
        {/* <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-5 lg:mb-8 order-3 lg:order-2">
          <Meta
            label="Issues"
            value="Pemuda, Pelajar"
          />
        </div> */}
        {/* <div className="w-full lg:w-auto px-2 lg:px-0 mb-5 lg:mb-8 order-1 lg:order-3">
          <Meta
            label="Suitable for"
            value="Educator, Donor, Professionals"
          />
        </div> */}
      </div>

      {/* {
        isOfficial &&
        <div className="mb-5 lg:mb-8">
          <p className="text-xs lg:font-bold mb-2 text-gray-999 lg:text-black">Partner</p>
          <User small name="AIPJ2" className="mb-2"/>
          <User small name="Maarif Institute"/>
        </div>
      } */}

      {/* <div className="">
        <p className="text-xs lg:font-bold mb-2 text-gray-999 lg:text-black">Officer</p>
        <Link to="/profile">
          <User small name="Mahmud Albizar"/>
        </Link>
      </div> */}

      <hr className="my-8 lg:my-10"/>

      <div className="">
        <p className="text-sm font-bold mb-2">Date</p>
        <p className="text-gray-444 text-sm">
          {
            data && data.date ? data.date : (
              <span>Oct 6, 2020 – Mon, Oct 12, 2020</span>
            )
          }
        </p>
      </div>

      {/* <div className="mb-8 lg:mb-10">
        <p className="text-xs font-bold mb-2">Date and Time</p>
        <p className="text-gray-444 text-sm">Tue, Oct 6, 2020, 2:00 PM –<br />Mon, Oct 12, 2020, 8:00 PM CAT</p>
      </div> */}

      <hr className="my-8 lg:my-10"/>

      <div>
        <p className="text-sm font-bold mb-4 lg:mb-8">Location</p>
        <div className="mb-5 lg:mb-8">
          <p className="text-sm font-bold mb-2">Bandung</p>
          <p className="text-gray-444 text-sm">
            Hotel Grand Tjokro<br />
            Jalan Cihampelas 234
          </p>
        </div>
        <div className="mb-5 lg:mb-8">
          <p className="text-sm font-bold mb-2">Jakarta</p>
          <p className="text-gray-444 text-sm">
          Hotel Grand Tjokro<br />
          Jalan Daan Mogot No.63<br />
          Tj. Duren Utara<br />
          Kec. Grogol petamburan, Daerah Khusus Ibukota Jakarta 11470
          </p>
        </div>
      </div>

      <hr className="my-8 lg:my-10"/>

      {/* <div className="mb-8 lg:mb-10">
        <p className="text-sm font-bold mb-5 lg:mb-2">Milestones</p>
        <Milestone text="Call for proposal" className="mb-4 lg:mb-2"/>
        <Milestone text="Selection for process" className="mb-4 lg:mb-2"/>
        <Milestone text="ToT project management plan" className="mb-4 lg:mb-2"/>
        <Milestone text="Training for Fasilitator" className="mb-4 lg:mb-2"/>
        <Milestone text="Training for Teacher" className="mb-4 lg:mb-2"/>
        <Milestone text="Implementation at school" className="mb-4 lg:mb-2" disabled/>
        <Milestone text="BDW at 2 schools" className="mb-4 lg:mb-2" disabled/>
        <Milestone text="Monitoring &amp; evaluation" className="mb-4 lg:mb-2" disabled/>
      </div> */}

      <ReportSection data={data} />

      <hr className="my-8 lg:my-10"/>

      <div className="lg:mb-10">
        <p className="text-xs font-bold mb-5 text-center lg:text-left">Share this initiative</p>
        <div className="flex items-center justify-center lg:justify-start -mx-2">
          <div className="w-1/4 lg:w-1/3 px-2">
            <div
              className="rounded border text-primary text-xs text-center px-2 py-1 cursor-pointer"
              style={{borderColor: colors.primary}}
            >
              Copy
            </div>
          </div>
          <div className="w-auto lg:w-1/3 px-2">
            <div className="flex items-center">
              <img className="mr-2 cursor-pointer" src="/images/logos/khub_facebook-logo.svg" alt="facebook"/>
              <img className="mr-2 cursor-pointer" src="/images/logos/khub_twitter.svg" alt="twitter"/>
              <img className="lg:mr-2 cursor-pointer" src="/images/logos/khub_linkedin.svg" alt="linkedin"/>
            </div>
          </div>
        </div>
      </div>

      <hr className="lg:hidden my-8"/>
    </div>
  )
}

export { Sidebar }
